const tableHeadings = (classes) => ([
  {
    id: 'appClientName',
    header: 'APP CLIENT NAME',
  },
  {
    id: 'clientId',
    header: 'CLIENT ID',
    isPopover: true,
    popoverContent: 'Unique identifier for the app client and must be used to generate the access tokens'
  },
  {
    id: 'clientSecret',
    header: 'CLIENT SECRET',
    isPopover: true,
    popoverContent: 'Unique for the app client and must be used to generate the access tokens. Must never be shared with anyone'
  },
  {
    id: 'acions',
    className: classes.tableActions,
    header: 'ACTIONS'
  }
])

const programOAuthTableHeadings = (classes) => ([
  {
    id: 'programName',
    header: 'PROGRAM NAME',
  },
  {
    id: 'programId',
    header: 'PROGRAM ID',
    isPopover: true,
    popoverContent: 'Unique identifier for the program'
  },
  {
    id: 'oAuthClientId',
    header: 'OAUTH CLIENT ID',
    isPopover: true,
    popoverContent: 'Unique identifier for the oAuth program client and must be used to generate the access tokens'
  },
  {
    id: 'oAuthClientSecret',
    header: 'OAUTH CLIENT SECRET',
    isPopover: true,
    popoverContent: 'Unique for the oAuth app client and must be used to generate the access tokens. Must never be shared with anyone'
  }
])

const oAuthUrl = () => {
  let hostname, url = ''
  if (typeof window !== 'undefined') {
    hostname = window.location.hostname
    if (hostname.search('grid.enphaseenergy.com') >= 0) {
      url = 'https://api.enphaseenergy.com/oauth/authorize'
    } else if (hostname.search('grid-preprod.enphaseenergy.com') >= 0) {
      url = 'https://api-preprod.enphaseenergy.com/oauth/authorize'
    } else if (hostname.search('gs-console-stg.qa-enphaseenergy.com') >= 0) {
      url = 'https://api-qa2.enphaseenergy.com/oauth/authorize'
    } else if (hostname.search('gs-admin-ui-intg.qa-enphaseenergy.com') >= 0) {
      url = 'https://api-intg.qa-enphaseenergy.com/oauth/authorize'
    } else if (hostname.search('grid-rel.qa-enphaseenergy.com') >= 0) {
      url = 'https://enl-api-rel.enphaseenergy.com/oauth/authorize'
    } else if (hostname.search('gs-admin-ui-dev.qa-enphaseenergy.com') >= 0) {
      url = 'https://api-dev.qa-enphaseenergy.com/oauth/authorize'
    } else {
      url = 'https://api-dev.qa-enphaseenergy.com/oauth/authorize'
    }
  }
  return url
}

export {
  tableHeadings,
  programOAuthTableHeadings,
  oAuthUrl
}